import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { VOCI_TUTTE, VOCI_LABEL } from '../lib/calcoli'
import { clearTariffeCache } from '../lib/dataloader'

export default function AdminEirTassi() {
  const [tassi, setTassi] = useState([])
  const [edits, setEdits] = useState({})  // key: id -> nuovo valore
  const [filter, setFilter] = useState({ stato_veicolo: 'nuovo', con_loc: false })
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const { data } = await supabase.from('eir_tassi').select('*').order('zona')
    setTassi(data || [])
    setLoading(false)
  }

  async function saveAll() {
    setSaving(true)
    for (const [id, valore] of Object.entries(edits)) {
      await supabase.from('eir_tassi').update({ valore: parseFloat(valore) }).eq('id', parseInt(id))
    }
    setEdits({})
    clearTariffeCache()
    await load()
    setSaving(false)
  }

  if (loading) return <div className="loading">Caricamento...</div>

  const filtered = tassi.filter(t =>
    t.stato_veicolo === filter.stato_veicolo && t.con_loc === filter.con_loc)

  // Costruisce matrice [voce][zona]
  const matrix = {}
  for (const t of filtered) {
    matrix[t.voce] = matrix[t.voce] || {}
    matrix[t.voce][t.zona] = t
  }

  const dirty = Object.keys(edits).length > 0

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Tassi EIR</h1>
          <p>Tassi lordi per zona territoriale (1..5). Modifica il valore in cella e salva. Le modifiche valgono per tutti i dealer immediatamente.</p>
        </div>
        {dirty && <button className="btn btn-primary" onClick={saveAll} disabled={saving}>{saving ? 'Salvataggio...' : `Salva ${Object.keys(edits).length} modifiche`}</button>}
      </div>

      <div className="card">
        <div className="tabs">
          <div className={`tab ${filter.stato_veicolo==='nuovo' && !filter.con_loc?'active':''}`} onClick={() => setFilter({stato_veicolo:'nuovo',con_loc:false})}>Nuovo · senza LOC</div>
          <div className={`tab ${filter.stato_veicolo==='nuovo' && filter.con_loc?'active':''}`} onClick={() => setFilter({stato_veicolo:'nuovo',con_loc:true})}>Nuovo · con LOC</div>
          <div className={`tab ${filter.stato_veicolo==='usato' && !filter.con_loc?'active':''}`} onClick={() => setFilter({stato_veicolo:'usato',con_loc:false})}>Usato · senza LOC</div>
          <div className={`tab ${filter.stato_veicolo==='usato' && filter.con_loc?'active':''}`} onClick={() => setFilter({stato_veicolo:'usato',con_loc:true})}>Usato · con LOC</div>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Voce</th>
                <th>Zona 1</th><th>Zona 2</th><th>Zona 3</th><th>Zona 4</th><th>Zona 5</th>
              </tr>
            </thead>
            <tbody>
              {VOCI_TUTTE.map(voce => (
                <tr key={voce}>
                  <td><strong>{VOCI_LABEL[voce]}</strong> <span className="text-muted text-small">({voce})</span></td>
                  {[1,2,3,4,5].map(z => {
                    const t = matrix[voce]?.[z]
                    if (!t) return <td key={z} className="text-muted">—</td>
                    const val = edits[t.id] !== undefined ? edits[t.id] : t.valore
                    const isDirty = edits[t.id] !== undefined
                    return (
                      <td key={z}>
                        <input type="number" step="0.0001" value={val}
                               onChange={e => setEdits(s => ({ ...s, [t.id]: e.target.value }))}
                               style={{ width: 110, background: isDirty ? '#FFF7E5' : 'transparent' }} />
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
